<template>
  <div class="mobile-header">
    <div class="ml-3">
      <img
        src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
        alt=""
      />
    </div>

    <div class="d-flex align-items-center mr-2">
      <div
        class="position-relative"
        @click="showsignout = !showsignout"
        v-closable="{
          exclude: ['profile-image'],
          handler: 'closeDpcard',
        }"
      >
        <img
          class="mb-profile-pic-1"
          :src="profileIcon ? profileIcon : userInfo.profileImage"
          alt=""
        />
        <div v-if="showsignout" class="mb-header-box">
          <div class="mb-header-name">
            <img
              class="mr-1 mb-profile-pic-2"
              :src="profileIcon ? profileIcon : userInfo.profileImage"
              alt=""
            />

            {{ roleValues.username ? `${roleValues.username}` : `${extPanel}` }}
          </div>
          <div
            v-if="this.$route.name != 'PanelDetails'"
            class="mb-resume-name-2 d-flex align-items-center mt-3 mb-3"
            @click="myProfile()"
          >
            <img
              class="mr-1"
              src="../../assets/New Profile/Settings.svg"
              alt=""
            />
            Account Settings
          </div>

          <div class="demograpgic-data"></div>
          <div
            class="
              d-flex
              align-items-center
              justify-content-center
              mt-2
              sign-out-font
            "
            @click="logout()"
          >
            <img src="../../assets/New Profile/Logout.svg" alt="" />
            Sign Out
          </div>
        </div>
      </div>
    </div>

    <!-- <img class="cv-logo" src="../../assets/img/h3xlogo.svg" alt="" />
    <div
      ref="dropdown"
      class="position-relative pointer"
      @click="toggleDropdown"
    >
      <img class="mr-3" src="../../assets/panelMob/user.svg" alt="" />

      <div class="position-absolute">
        <div
          v-if="showdpcard"
          class="tnt-sortcard headercard p-0 panel-sortcard"
        >
          <div class="text-center">
            <img
              class="mt-2 mr-3"
              src="../../assets/panelMob/user.svg"
              alt=""
            />
            <div class="mt-2 panel-login-text">
              Welcome ,<strong v-if="roleValues.username">
                {{ roleValues.username }}</strong
              >
              <strong v-else> {{ extPanel }}</strong>
            </div>
            <hr style="width: 181px" />
            <div
              class="d-flex align-items-center justify-content-center mb-2"
              @click="logout()"
            >
              <img src="../../assets/panelMob/mobile-logout.svg" alt="" />
              <div class="p-2 panel-logout-text">LOG OUT</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LogoutMixins } from "../../views/login/LogoutMixins";
import { getLoggedInUserEmail } from "../../utils/request";
import { checkExternalPanelist } from "../../utils/tokenCheck";
export default {
  name: "MobileHeader",
  mixins: [LogoutMixins],

  data() {
    return {
      showsignout: false,
      profileIcon: "",
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      extPanel: "getLoggedInUserEmail",
      userInfo: "getUserDetail",
    }),
  },
  created() {
    console.log("this", this.userInfo);
    if (this.$route.name == "PanelDetails" && checkExternalPanelist()) {
      let email = getLoggedInUserEmail();
      this.$store.commit("userVUEX/saveUserEmail", email);
      this.getUsericon();
    }
  },
  methods: {
    myProfile() {
      this.$router.push({
        name: "MobileProfile",
      });
    },
    toggleDropdown() {
      this.showdpcard = !this.showdpcard;

      if (this.showdpcard) {
        document.addEventListener("click", this.closeDropdown);
      } else {
        document.removeEventListener("click", this.closeDropdown);
      }
    },
    closeDropdown(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.showdpcard = false;

        document.removeEventListener("click", this.closeDropdown);
      }
    },
    closeDpcard() {
      this.showsignout = false;
    },
    handleClick() {
      this.showdpcard = !this.showdpcard;
    },
  },
};
</script>

<style>
.mb-resume-name-2 {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3a3c40;
}
.mb-profile-pic-1 {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0px 4px 4px 0px #00000040;
  border: 1px solid #ffffff;
}

.mb-profile-pic-2 {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.panel-login-text {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: #1a4164;
  font-size: 12px;
}
.panel-logout-text {
  color: #72738e;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 12px;
}
.panel-sortcard {
  width: 200px;
  top: 2px;
  right: -40px;
  border-radius: 1px;
}
.sign-out-font {
  color: #20639b;
  font-size: 14px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}
.mobile-header {
  background: #fff;
  box-shadow: 0px 4px 20px 0px #000;
  height: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mb-header-box {
  position: absolute;
  background-color: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 4px;
  width: 250px;
  z-index: 5;
  right: 0px;
  padding: 10px 14px;
}

.mb-header-name {
  background-color: #20639b;
  border-radius: 5px;
  color: #ffffff;
  padding: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: "lato", sans-serif;
}
</style>
